window.Axiom = window.Axiom || {};

(function () {
  'use strict';

  var drawer = null;
  var overlay = null;
  var bodyEl = null;
  var qtyQueue = new Map();
  var qtyFeedbackQueue = new Map();
  var qtyFlushTimer = null;
  var qtyRequestActive = false;
  var qtyMutationVersion = 0;
  var documentKeydownBound = false;
  var panelSuccessCloseTimer = null;
  function cartString(key, fallback) {
    return (window.Axiom && window.Axiom.cartStrings && window.Axiom.cartStrings[key]) || fallback || '';
  }

  function getCurrentCartCount() {
    var countEl = document.querySelector('[data-cart-count]');
    var count = countEl ? parseInt(countEl.textContent, 10) : 0;
    return Number.isFinite(count) ? count : 0;
  }

  function getDrawer() {
    if (!drawer) drawer = document.getElementById('cart-drawer');
    return drawer;
  }

  function getOverlay() {
    if (!overlay) overlay = document.getElementById('site-overlay');
    return overlay;
  }

  function isDrawerMode() {
    return !window.Axiom || (window.Axiom.cartType || 'drawer') === 'drawer';
  }

  function openCartDrawer(explicitReturnFocus) {
    var d = getDrawer();
    var o = getOverlay();
    if (!d) return;
    var closeBtn = d.querySelector('[data-cart-drawer-close]');
    var returnFocus = explicitReturnFocus && explicitReturnFocus.isConnected
      ? explicitReturnFocus
      : (d.contains(document.activeElement) ? null : document.activeElement);
    if (window.Axiom && typeof window.Axiom.openDrawer === 'function') {
      window.Axiom.openDrawer(d, o, {
        autofocus: true,
        focusTarget: closeBtn,
        returnFocus: returnFocus,
        trapFocus: true
      });
    } else {
      d.setAttribute('aria-hidden', 'false');
      d.removeAttribute('inert');
      d.classList.add('is-open');
      if (o) { o.classList.add('is-open'); }
      document.documentElement.classList.add('is-scroll-locked');
      if (closeBtn) closeBtn.focus();
    }
    document.dispatchEvent(new CustomEvent('theme:cart-drawer:open', { detail: { drawer: d } }));
  }

  function setDrawerLoading(isLoading) {
    var d = getDrawer();
    if (!d) return;
    d.classList.toggle('is-loading', Boolean(isLoading));
  }

  function closeCartDrawer() {
    var d = getDrawer();
    var o = getOverlay();
    if (!d) return;
    closeCartPanel();
    if (window.Axiom && typeof window.Axiom.closeDrawer === 'function') {
      window.Axiom.closeDrawer(d, o);
    } else {
      d.setAttribute('aria-hidden', 'true');
      d.setAttribute('inert', '');
      d.classList.remove('is-open');
      if (o) { o.classList.remove('is-open'); }
      document.documentElement.classList.remove('is-scroll-locked');
    }
    document.dispatchEvent(new CustomEvent('theme:cart-drawer:close', { detail: { drawer: d } }));
  }

  function cartDrawerSectionId() {
    var d = getDrawer();
    return d && d.dataset.sectionId || '';
  }

  function updateCartCount(count) {
    if (window.Axiom && typeof window.Axiom.updateCartCount === 'function') {
      window.Axiom.updateCartCount(count);
      return;
    }
    var badges = document.querySelectorAll('[data-cart-count]');
    badges.forEach(function (badge) {
      var valueEl = badge.querySelector('[data-cart-count-value]') || badge;
      valueEl.textContent = count;
      badge.style.display = count > 0 ? '' : 'none';
    });
    document.querySelectorAll('[data-cart-drawer-count]').forEach(function (element) {
      var next = Number(count);
      if (!Number.isFinite(next)) next = 0;
      element.textContent = ' (' + next + ')';
      element.hidden = next <= 0;
    });
  }

  function updateCartCountOptimistic(delta) {
    updateCartCount(Math.max(0, getCurrentCartCount() + delta));
  }

  function standard() {
    return window.AxiomStandardStorefront || null;
  }

  function getStandardCartLines(cart) {
    var api = standard();
    return api && typeof api.getCartLines === 'function' ? api.getCartLines(cart) : [];
  }

  function getStandardCartTotalQuantity(cart) {
    var api = standard();
    return api && typeof api.getCartTotalQuantity === 'function' ? api.getCartTotalQuantity(cart) : 0;
  }

  function findStandardCartLine(cart, identifier) {
    var id = String(identifier || '');
    return getStandardCartLines(cart).find(function (line) {
      return line && String(line.id || '') === id;
    }) || null;
  }

  function firstWarningMessage(result) {
    var warning = result && Array.isArray(result.warnings) ? result.warnings[0] : null;
    return warning && (warning.message || warning.code) || '';
  }

  function normalizeDiscountCode(code) {
    return String(code || '').trim().toLocaleLowerCase();
  }

  function getCartDiscountCodes(cart) {
    return cart && Array.isArray(cart.discountCodes) ? cart.discountCodes : [];
  }

  function findCartDiscountCode(cart, code) {
    var normalizedCode = normalizeDiscountCode(code);
    return getCartDiscountCodes(cart).find(function (discountCode) {
      return discountCode && normalizeDiscountCode(discountCode.code) === normalizedCode;
    }) || null;
  }

  function discountCodeErrorMessage(result, code) {
    var warnings = result && Array.isArray(result.warnings) ? result.warnings : [];
    var missingCodeWarning = warnings.find(function (warning) {
      return warning && warning.code === 'DISCOUNT_NOT_FOUND';
    });
    if (missingCodeWarning) {
      return missingCodeWarning.message || cartString('couponError');
    }

    var discountCode = findCartDiscountCode(result && result.cart, code);
    if (!discountCode || discountCode.applicable !== true) {
      return firstWarningMessage(result) || cartString('couponError');
    }

    return '';
  }

  function cartUpdateErrorMessage(error) {
    return error && error.message || cartString('updateError', 'We could not update this item. Please try again.');
  }

  function quantityLimitMessage(count) {
    return standard().quantityLimitMessage(count);
  }

  function findDrawerItem(identifier) {
    var id = String(identifier || '');
    var d = getDrawer();
    return Array.from(d ? d.querySelectorAll('.cart-item[data-cart-line-id]') : []).find(function (item) {
      return String(item.dataset.cartLineId || '') === id;
    }) || null;
  }

  function setAlert(alert, message) {
    if (!alert) return;
    alert.textContent = '';
    alert.hidden = !message;
    if (!message) return;
    window.requestAnimationFrame(function () {
      if (alert.isConnected) alert.textContent = message;
    });
  }

  function setPanelStatus(status, message, tone) {
    if (!status) return;
    status.textContent = message || '';
    if (tone) {
      status.dataset.status = tone;
    } else {
      delete status.dataset.status;
    }
  }

  function clearDrawerLineFeedback(identifier) {
    var d = getDrawer();
    if (!d) return;
    setAlert(d.querySelector('[data-cart-status]'), '');
    var item = findDrawerItem(identifier);
    if (item) setAlert(item.querySelector('[data-cart-line-error]'), '');
  }

  function showDrawerLineFeedback(identifier, message) {
    if (!message) return;
    var d = getDrawer();
    if (!d) return;
    var item = findDrawerItem(identifier);
    var alert = item && item.querySelector('[data-cart-line-error]');
    setAlert(alert || d.querySelector('[data-cart-status]'), message);
  }

  function setDrawerItemUpdating(item, isUpdating, isRemoving) {
    if (!item) return;
    item.classList.toggle('is-updating', Boolean(isUpdating));
    if (typeof isRemoving === 'boolean') item.classList.toggle('is-removing', isRemoving);
    item.setAttribute('aria-busy', isUpdating ? 'true' : 'false');
    var status = item.querySelector('[data-cart-line-loading-status]');
    if (status) status.textContent = isUpdating ? cartString('updating', 'Loading') : '';
  }

  function clearDrawerQuantityStates() {
    var d = getDrawer();
    if (!d) return;
    d.querySelectorAll('.cart-item.is-updating, .cart-item.is-removing').forEach(function (item) {
      setDrawerItemUpdating(item, false, false);
    });
  }

  function restoreConfirmedQuantities(requested, cart) {
    requested.forEach(function (entry) {
      var item = findDrawerItem(entry.identifier);
      var line = findStandardCartLine(cart, entry.identifier);
      var value = item && item.querySelector('.cart-item__qty-val');
      if (value && line) value.textContent = line.quantity;
    });
    updateCartCount(getStandardCartTotalQuantity(cart));
    clearDrawerQuantityStates();
  }

  function setRequestedItemsUpdating(requested) {
    requested.forEach(function (entry) {
      setDrawerItemUpdating(findDrawerItem(entry.identifier), true, entry.quantity === 0);
    });
  }

  function annotateCartLineIds(cart, root) {
    var target = root || getDrawer();
    if (!target) return;
    var lines = getStandardCartLines(cart);
    target.querySelectorAll('.cart-item').forEach(function (itemEl, index) {
      var line = lines[index];
      var lineId = itemEl.dataset.key || line && line.id;
      if (!lineId) return;
      itemEl.dataset.cartLineId = lineId;
      itemEl.querySelectorAll('.cart-item__qty-btn, .cart-item__remove').forEach(function (control) {
        control.dataset.cartLineId = lineId;
      });
    });
  }


  function renderedSectionQuantity(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var section = doc.getElementById('cart-drawer');
    if (!section) return null;
    return Array.from(section.querySelectorAll('.cart-item__qty-val')).reduce(function (total, element) {
      return total + (parseInt(element.textContent, 10) || 0);
    }, 0);
  }

  function replaceDrawerSection(html) {
    if (!html) return false;
    var current = getDrawer();
    if (!current) return false;
    var wasOpen = current.classList.contains('is-open');
    var wasLoading = current.classList.contains('is-loading');
    var activeControl = current.contains(document.activeElement) ? document.activeElement : null;
    var activeItem = activeControl && activeControl.closest('.cart-item[data-key]');
    var activeItemKey = activeItem && activeItem.dataset.key;
    var activeQuantityChange = activeControl && activeControl.matches('.cart-item__qty-btn')
      ? activeControl.dataset.change
      : null;
    var activeCloseControl = activeControl && activeControl.matches('[data-cart-drawer-close]');
    var currentScrollRegion = current.querySelector('[data-cart-drawer-scroll-region]');
    var scrollTop = currentScrollRegion ? currentScrollRegion.scrollTop : 0;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.getElementById('cart-drawer');
    if (!fresh) return false;

    current.className = fresh.className;
    if (wasOpen) {
      current.classList.add('is-open');
      current.setAttribute('aria-hidden', 'false');
      current.removeAttribute('inert');
    } else {
      current.setAttribute('aria-hidden', 'true');
      current.setAttribute('inert', '');
    }
    if (wasLoading) current.classList.add('is-loading');

    if (fresh.hasAttribute('style')) {
      current.setAttribute('style', fresh.getAttribute('style'));
    } else {
      current.removeAttribute('style');
    }
    if (fresh.dataset.sectionId) current.dataset.sectionId = fresh.dataset.sectionId;
    current.dataset.cartItemCount = fresh.dataset.cartItemCount || '0';
    current.dataset.cartTotalPrice = fresh.dataset.cartTotalPrice || '0';
    current.replaceChildren.apply(current, Array.from(fresh.childNodes));

    var freshScrollRegion = current.querySelector('[data-cart-drawer-scroll-region]');
    if (freshScrollRegion) freshScrollRegion.scrollTop = scrollTop;
    if (activeItemKey && activeQuantityChange !== null) {
      var matchingItem = Array.from(current.querySelectorAll('.cart-item[data-key]')).find(function (item) {
        return item.dataset.key === activeItemKey;
      });
      var matchingControl = matchingItem && matchingItem.querySelector('.cart-item__qty-btn[data-change="' + activeQuantityChange + '"]');
      if (matchingControl) matchingControl.focus({ preventScroll: true });
    } else if (activeCloseControl) {
      var matchingCloseControl = current.querySelector('[data-cart-drawer-close]');
      if (matchingCloseControl) matchingCloseControl.focus({ preventScroll: true });
    }

    if (window.Axiom && typeof window.Axiom.initCartShippingEstimators === 'function') {
      window.Axiom.initCartShippingEstimators(current);
    }
    document.dispatchEvent(new CustomEvent('cart:drawer:rendered', { detail: { drawer: current } }));
    return true;
  }

  function renderCartResponse(cart, options) {
    if (!cart) return;
    if (!isDrawerMode()) {
      updateCartCount(getStandardCartTotalQuantity(cart));
      return Promise.resolve(cart);
    }
    var sectionId = cartDrawerSectionId();
    var bundled = cart.sections && cart.sections[sectionId];
    if (!bundled) {
      return Promise.reject(new Error('Bundled cart drawer section failed to render.'));
    }
    return Promise.resolve(bundled).then(function (html) {
      if (options && typeof options.shouldRender === 'function' && !options.shouldRender()) return cart;
      replaceDrawerSection(html);
      annotateCartLineIds(cart);
      var sectionQuantity = renderedSectionQuantity(html);
      updateCartCount(sectionQuantity === null ? getStandardCartTotalQuantity(cart) : sectionQuantity);
      return cart;
    });
  }

  function renderCartResponseWithSection(cart) {
    return renderCartResponse(cart);
  }

  function closeCartPanel() {
    var d = getDrawer();
    if (!d) return;
    var restoreTrigger = null;
    if (panelSuccessCloseTimer) {
      window.clearTimeout(panelSuccessCloseTimer);
      panelSuccessCloseTimer = null;
    }
    d.querySelectorAll('[data-cart-drawer-panel]').forEach(function (panel) {
      if (panel.classList.contains('is-open') && panel.contains(document.activeElement)) {
        restoreTrigger = d.querySelector('[data-cart-drawer-panel-trigger="' + panel.dataset.cartDrawerPanel + '"]');
      }
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      panel.setAttribute('inert', '');
    });
    d.querySelectorAll('[data-cart-drawer-panel-trigger]').forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
    });
    if (restoreTrigger) restoreTrigger.focus({ preventScroll: true });
  }

  function closeCartPanelAfterSuccess(type, delay) {
    if (panelSuccessCloseTimer) window.clearTimeout(panelSuccessCloseTimer);
    panelSuccessCloseTimer = window.setTimeout(function () {
      panelSuccessCloseTimer = null;
      var d = getDrawer();
      if (!d) return;
      var panel = d.querySelector('[data-cart-drawer-panel="' + type + '"]');
      if (!panel || !panel.classList.contains('is-open')) return;
      var trigger = d.querySelector('[data-cart-drawer-panel-trigger="' + type + '"]');
      var restoreFocus = panel.contains(document.activeElement);
      closeCartPanel();
      if (restoreFocus && trigger) trigger.focus({ preventScroll: true });
    }, typeof delay === 'number' ? delay : 1000);
  }

  function openCartPanel(type) {
    var d = getDrawer();
    if (!d) return;
    var panel = d.querySelector('[data-cart-drawer-panel="' + type + '"]');
    var trigger = d.querySelector('[data-cart-drawer-panel-trigger="' + type + '"]');
    if (!panel) return;
    var isOpen = panel.classList.contains('is-open');
    closeCartPanel();
    if (isOpen) return;
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    panel.removeAttribute('inert');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    if (type === 'shipping' && window.Axiom && typeof window.Axiom.initCartShippingEstimators === 'function') {
      window.Axiom.initCartShippingEstimators(panel);
    }
    var focusTarget = panel.querySelector('textarea, select, input') || panel.querySelector('button');
    if (focusTarget) focusTarget.focus();
  }

  function scheduleQuantityFlush(delay) {
    if (qtyFlushTimer) window.clearTimeout(qtyFlushTimer);
    qtyFlushTimer = window.setTimeout(function () {
      qtyFlushTimer = null;
      flushQuantityQueue();
    }, delay);
  }

  function queueQuantityUpdate(identifier, quantity) {
    qtyQueue.set(identifier, {
      identifier: identifier,
      quantity: quantity
    });
    qtyMutationVersion += 1;
    scheduleQuantityFlush(300);
  }

  function recordQuantityFeedback(result, requested) {
    requested.forEach(function (entry) {
      qtyFeedbackQueue.delete(entry.identifier);
      var line = findStandardCartLine(result && result.cart, entry.identifier);
      var actualQuantity = line ? Number(line.quantity) : 0;
      if (entry.quantity > 0 && actualQuantity !== entry.quantity) {
        qtyFeedbackQueue.set(entry.identifier, quantityLimitMessage(actualQuantity));
      }
    });
    var inventoryWarning = (result && Array.isArray(result.warnings) ? result.warnings : []).find(function (warning) {
      return warning && (warning.code === 'MERCHANDISE_NOT_ENOUGH_STOCK' || warning.code === 'MERCHANDISE_OUT_OF_STOCK');
    });
    var warningTargetId = inventoryWarning && String(inventoryWarning.target || '');
    var warningTarget = inventoryWarning && requested.find(function (entry) {
      return entry.quantity > 0 && !qtyFeedbackQueue.has(entry.identifier) && (
        !warningTargetId || String(entry.identifier) === warningTargetId
      );
    });
    if (warningTarget) {
      var warningLine = findStandardCartLine(result && result.cart, warningTarget.identifier);
      qtyFeedbackQueue.set(
        warningTarget.identifier,
        quantityLimitMessage(warningLine ? Number(warningLine.quantity) : warningTarget.quantity)
      );
    }
  }

  function showQuantityFeedbackQueue() {
    qtyFeedbackQueue.forEach(function (message, identifier) {
      showDrawerLineFeedback(identifier, message);
    });
    qtyFeedbackQueue.clear();
  }

  function flushQuantityQueue() {
    if (qtyRequestActive || qtyQueue.size === 0) return;
    var requested = Array.from(qtyQueue.values());
    var requestVersion = qtyMutationVersion;
    qtyQueue.clear();
    qtyRequestActive = true;
    setRequestedItemsUpdating(requested);

    standard().updateCart({
      lines: requested.map(function (entry) {
        return { id: entry.identifier, quantity: entry.quantity };
      })
    }, { target: getDrawer(), context: 'cart', source: 'cart-drawer' })
      .then(function (result) {
        recordQuantityFeedback(result, requested);
        if (qtyQueue.size > 0 || requestVersion !== qtyMutationVersion) return result.cart;
        return renderCartResponse(result.cart, {
          shouldRender: function () {
            return requestVersion === qtyMutationVersion && qtyQueue.size === 0;
          }
        }).then(function () {
          if (requestVersion === qtyMutationVersion && qtyQueue.size === 0) {
            showQuantityFeedbackQueue();
          }
          return result.cart;
        });
      })
      .catch(function (err) {
        console.error('Cart update error:', err);
        qtyQueue.clear();
        qtyFeedbackQueue.clear();
        qtyMutationVersion += 1;
        var message = cartUpdateErrorMessage(err);
        var refreshedCart = null;
        return standard().refreshCart()
          .then(function (cart) {
            refreshedCart = cart;
            return renderCartResponse(cart);
          })
          .then(function () {
            var requestedLine = requested[0];
            var serverLine = requestedLine && findStandardCartLine(refreshedCart, requestedLine.identifier);
            var feedback = requestedLine && serverLine && requestedLine.quantity > Number(serverLine.quantity)
              ? quantityLimitMessage(serverLine.quantity)
              : message;
            showDrawerLineFeedback(requestedLine && requestedLine.identifier, feedback);
          })
          .catch(function (refreshError) {
            console.error('Cart refresh error:', refreshError);
            return standard().fetchCart().then(function (confirmedCart) {
              restoreConfirmedQuantities(requested, confirmedCart);
              var requestedLine = requested[0];
              var confirmedLine = requestedLine && findStandardCartLine(confirmedCart, requestedLine.identifier);
              var feedback = requestedLine && confirmedLine && requestedLine.quantity > Number(confirmedLine.quantity)
                ? quantityLimitMessage(confirmedLine.quantity)
                : message;
              showDrawerLineFeedback(requestedLine && requestedLine.identifier, feedback);
            });
          });
      })
      .finally(function () {
        qtyRequestActive = false;
        if (qtyQueue.size > 0 && !qtyFlushTimer) scheduleQuantityFlush(0);
      });
  }

  function parseRuleNumber(value, fallback) {
    var parsed = parseInt(value, 10);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function getCartLineQuantityRule(itemEl) {
    var ruleEl = itemEl && itemEl.querySelector('[data-cart-quantity-rules]');
    return {
      min: Math.max(1, parseRuleNumber(ruleEl && ruleEl.dataset.minRule, 1)),
      max: ruleEl && ruleEl.dataset.maxRule !== '' && ruleEl.dataset.maxRule !== undefined
        ? parseRuleNumber(ruleEl.dataset.maxRule, null)
        : null,
      step: Math.max(1, parseRuleNumber(ruleEl && ruleEl.dataset.stepRule, 1))
    };
  }

  function normalizeCartLineQuantity(rawValue, rule, allowZero) {
    var value = parseInt(rawValue, 10);
    if (!Number.isFinite(value)) value = allowZero ? 0 : rule.min;
    if (allowZero && value <= 0) return 0;
    if (value < rule.min) value = rule.min;
    if (value > rule.min) {
      value -= (value - rule.min) % rule.step;
    }
    if (rule.max !== null && value > rule.max) {
      value = rule.max;
      if (value >= rule.min) value -= (value - rule.min) % rule.step;
    }
    if (rule.max !== null && rule.max < rule.min) return allowZero ? 0 : rule.min;
    return Math.max(allowZero ? 0 : rule.min, value);
  }

  function getNextCartLineQuantity(currentQty, direction, itemEl) {
    var rule = getCartLineQuantityRule(itemEl);
    var nextQty = currentQty;
    if (direction > 0) {
      nextQty = currentQty <= 0 ? rule.min : currentQty + rule.step;
      return normalizeCartLineQuantity(nextQty, rule, false);
    }
    nextQty = currentQty <= rule.min ? 0 : currentQty - rule.step;
    return normalizeCartLineQuantity(nextQty, rule, true);
  }

  function handleQtyChange(line, change) {
    var d = getDrawer();
    var itemEl = d && d.querySelector('.cart-item[data-line="' + line + '"]');
    var qtyEl = itemEl && itemEl.querySelector('.cart-item__qty-val');
    var currentQty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
    var rule = getCartLineQuantityRule(itemEl);
    var rawNextQty = change > 0
      ? (currentQty <= 0 ? rule.min : currentQty + rule.step)
      : (currentQty <= rule.min ? 0 : currentQty - rule.step);
    var newQty = getNextCartLineQuantity(currentQty, change, itemEl);
    var identifier = itemEl && itemEl.dataset.cartLineId;
    if (!identifier) return;
    clearDrawerLineFeedback(identifier);
    var limitMessage = change > 0 && rule.max !== null && rawNextQty > rule.max
      ? quantityLimitMessage(rule.max)
      : '';
    if (limitMessage) showDrawerLineFeedback(identifier, limitMessage);
    if (newQty === currentQty) return;
    if (qtyEl) qtyEl.textContent = newQty;
    updateCartCountOptimistic(newQty - currentQty);
    queueQuantityUpdate(identifier, newQty);
  }

  function bindDrawerEvents() {
    var d = getDrawer();
    if (!d || d.dataset.cartDrawerBound === 'true') return;
    d.dataset.cartDrawerBound = 'true';

    d.addEventListener('click', function (e) {
      var closeBtn = e.target.closest('[data-cart-drawer-close]');
      if (closeBtn) { closeCartDrawer(); return; }

      var panelTrigger = e.target.closest('[data-cart-drawer-panel-trigger]');
      if (panelTrigger) {
        e.preventDefault();
        openCartPanel(panelTrigger.dataset.cartDrawerPanelTrigger);
        return;
      }

      var panelClose = e.target.closest('[data-cart-drawer-panel-close]');
      if (panelClose) {
        e.preventDefault();
        closeCartPanel();
        return;
      }

      var countrySelect = e.target.closest('[data-cart-shipping-country]');
      if (countrySelect) {
        updateCartProvinceSelect(d);
        return;
      }

      var noteSave = e.target.closest('[data-cart-note-save]');
      if (noteSave) {
        e.preventDefault();
        var noteInput = d.querySelector('[data-cart-note-input]');
        var noteStatus = d.querySelector('[data-cart-note-status]');
        noteSave.disabled = true;
        if (noteStatus) noteStatus.textContent = cartString('saving');
        standard().updateNote(noteInput ? noteInput.value : '', { target: d, source: 'cart-drawer' })
          .then(function (result) {
            return renderCartResponse(result.cart);
          })
          .then(function () {
            var freshStatus = getDrawer().querySelector('[data-cart-note-status]');
            if (freshStatus) freshStatus.textContent = cartString('noteSaved');
            openCartPanel('note');
            closeCartPanelAfterSuccess('note');
          })
          .catch(function (err) {
            console.error('Cart note update error:', err);
            if (noteStatus) noteStatus.textContent = cartString('noteSaveError');
          })
          .finally(function () {
            noteSave.disabled = false;
          });
        return;
      }

      var volumeToggle = e.target.closest('[data-cart-volume-toggle]');
      if (volumeToggle) {
        e.preventDefault();
        var panel = document.getElementById(volumeToggle.getAttribute('aria-controls'));
        var expanded = volumeToggle.getAttribute('aria-expanded') === 'true';
        volumeToggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        if (panel) panel.hidden = expanded;
        return;
      }

      var qtyBtn = e.target.closest('.cart-item__qty-btn');
      if (qtyBtn) {
        e.preventDefault();
        var line = parseInt(qtyBtn.dataset.line, 10);
        var change = parseInt(qtyBtn.dataset.change, 10);
        handleQtyChange(line, change);
        return;
      }

      var clearBtn = e.target.closest('[data-cart-clear]');
      if (clearBtn) {
        e.preventDefault();
        clearBtn.disabled = true;
        setDrawerLoading(true);
        standard().clearCart({ target: d, source: 'cart-drawer' })
          .then(function (result) {
            return renderCartResponse(result.cart);
          })
          .catch(function (err) {
            console.error('Cart clear error:', err);
            showDrawerLineFeedback('', cartUpdateErrorMessage(err));
          })
          .finally(function () {
            setDrawerLoading(false);
            clearBtn.disabled = false;
          });
        return;
      }

      var discountRemove = e.target.closest('[data-cart-discount-remove]');
      if (discountRemove) {
        e.preventDefault();
        var removedCode = discountRemove.dataset.cartDiscountRemove || '';
        var discountStatus = d.querySelector('[data-cart-discount-status]');
        var restoreDiscountFocus = document.activeElement === discountRemove;
        discountRemove.disabled = true;

        standard().getCart()
          .then(function (cart) {
            var remainingCodes = getCartDiscountCodes(cart).map(function (discountCode) {
              return discountCode && discountCode.code || '';
            }).filter(function (code) {
              return code && normalizeDiscountCode(code) !== normalizeDiscountCode(removedCode);
            });
            return standard().updateDiscounts(remainingCodes, { target: d, source: 'cart-drawer' });
          })
          .then(function (result) {
            return renderCartResponse(result.cart);
          })
          .then(function () {
            if (!restoreDiscountFocus) return;
            var currentDrawer = getDrawer();
            var couponTrigger = currentDrawer && currentDrawer.querySelector('[data-cart-drawer-panel-trigger="coupon"]');
            if (couponTrigger) couponTrigger.focus({ preventScroll: true });
          })
          .catch(function (err) {
            console.error('Cart discount removal error:', err);
            if (discountStatus) discountStatus.textContent = cartString('couponError');
            discountRemove.disabled = false;
          });
        return;
      }

      var removeBtn = e.target.closest('.cart-item__remove');
      if (removeBtn) {
        e.preventDefault();
        var line = parseInt(removeBtn.dataset.line, 10);
        var itemEl = d.querySelector('.cart-item[data-line="' + line + '"]');
        var qtyEl = itemEl && itemEl.querySelector('.cart-item__qty-val');
        var currentQty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
        var identifier = itemEl && itemEl.dataset.cartLineId;
        if (!identifier) return;
        clearDrawerLineFeedback(identifier);
        if (qtyEl) qtyEl.textContent = 0;
        updateCartCountOptimistic(-currentQty);
        queueQuantityUpdate(identifier, 0);
        return;
      }
    });
    d.addEventListener('submit', function (e) {
      var couponForm = e.target.closest('[data-cart-coupon-form]');
      if (couponForm) {
        e.preventDefault();
        if (panelSuccessCloseTimer) {
          window.clearTimeout(panelSuccessCloseTimer);
          panelSuccessCloseTimer = null;
        }
        var couponInput = couponForm.querySelector('[name="discount"]');
        var couponStatus = d.querySelector('[data-cart-coupon-status]');
        var submit = couponForm.querySelector('[type="submit"]');
        var code = couponInput ? couponInput.value.trim() : '';
        if (!code) {
          setPanelStatus(couponStatus, cartString('couponRequired'), 'warning');
          return;
        }
        if (submit) submit.disabled = true;
        setPanelStatus(couponStatus, cartString('couponApplying'), 'neutral');
        standard().updateDiscounts([code], { target: d, source: 'cart-drawer' })
          .then(function (result) {
            var discountError = discountCodeErrorMessage(result, code);
            if (discountError) {
              var error = new Error(discountError);
              error.name = 'AxiomDiscountCodeError';
              throw error;
            }
            return renderCartResponse(result.cart);
          })
          .then(function () {
            var freshStatus = getDrawer().querySelector('[data-cart-coupon-status]');
            setPanelStatus(freshStatus, cartString('couponApplied'), 'success');
            openCartPanel('coupon');
            closeCartPanelAfterSuccess('coupon', 2000);
          })
          .catch(function (err) {
            if (!err || err.name !== 'AxiomDiscountCodeError') {
              console.error('Cart coupon update error:', err);
            }
            var currentDrawer = getDrawer();
            var currentStatus = currentDrawer && currentDrawer.querySelector('[data-cart-coupon-status]');
            setPanelStatus(currentStatus, err && err.message || cartString('couponError'), 'warning');
            var currentPanel = currentDrawer && currentDrawer.querySelector('[data-cart-drawer-panel="coupon"]');
            if (currentPanel && !currentPanel.classList.contains('is-open')) openCartPanel('coupon');
          })
          .finally(function () {
            if (submit) submit.disabled = false;
          });
        return;
      }

    });

    var o = getOverlay();
    if (o && o.dataset.cartOverlayBound !== 'true') {
      o.dataset.cartOverlayBound = 'true';
      o.addEventListener('click', closeCartDrawer);
    }

    if (!documentKeydownBound) {
      documentKeydownBound = true;
      document.addEventListener('keydown', function (e) {
        var currentDrawer = getDrawer();
        if (e.key === 'Escape' && currentDrawer && currentDrawer.getAttribute('aria-hidden') === 'false') {
          if (currentDrawer.querySelector('[data-cart-drawer-panel].is-open')) {
            closeCartPanel();
            return;
          }
          closeCartDrawer();
        }
      });
    }
  }

  function init() {
    bindDrawerEvents();
    if (window.Axiom && typeof window.Axiom.initCartShippingEstimators === 'function') {
      window.Axiom.initCartShippingEstimators(getDrawer());
    }
    if (standard() && typeof standard().getCart === 'function') {
      standard().getCart().then(function (cart) {
        annotateCartLineIds(cart);
      }).catch(function () {});
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  Axiom.cart = {
    open: openCartDrawer,
    close: closeCartDrawer,
    fetch: function () {
      return standard().getCart();
    },
    render: renderCartResponseWithSection,
    renderStandard: renderCartResponseWithSection
  };
})();
